enum TypeCode {
    error = 1,
    warn,
    info,
  }

  interface SgmCustomType {
    type: TypeCode.error | TypeCode.warn | TypeCode.info | 'error' | 'warn' | 'info'; // 自定义类型（1-error,2-warn,3-info）
    code: string; // 自定义标示代码，可以是任意字符串，用于查询。最大长度128，超过将截取
    msg: string; // 自定义信息，可以传入对象。最大长度1024，超过将截取
    cost1?: number; // 计数字段，可和其他计数字段进行求和或者平均值计算，根据阈值进行告警
    cost2?: number; // 计数字段，可和其他计数字段进行求和或者平均值计算，根据阈值进行告警
    cost3?: number; // 计数字段，可和其他计数字段进行求和或者平均值计算，根据阈值进行告警
    cost4?: number; // 计数字段，可和其他计数字段进行求和或者平均值计算，根据阈值进行告警
  }

  /**
   * 获取当前项目的关键信息
   */
  export function getProjectInfo() {
    try {
      // 时间戳
      const timestamp = Date.now();
      // 缓存中的用户信息
      const userInfo = {
        erp: sessionStorage.getItem('erp'),
        tenantCode: sessionStorage.getItem('tenantCode'),
      };

      return {
        timestamp,
        userInfo,
      };
    } catch (error) {
      return {};
    }
  }

  /**
   * 自定义监控上报
   * @param params 上报数据
   * @param pid 业务id，如B商城H5
   */
  export function sgmCustom(params: SgmCustomType, pid?: string) {
    // 以防调用逻辑影响业务，切记一定进行catch
    try {
      const { timestamp, userInfo } = getProjectInfo();
      // 拼接关键信息
      params.type = typeof params.type === 'number' ? params.type : TypeCode[params.type] || TypeCode.info;
      params.code = params.code || '30001';
      params.msg = `[t=${JSON.stringify(timestamp)};userInfo=${JSON.stringify(userInfo)}]${params.msg}`;
      // pid: 将日志指定上报到某应用下。场景，例：前端组件、工具包监控（3.0.7 开始支持）。
      (window as any).__sgm__.custom(params, pid);
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 自定义监控上报
   * @param params 上报数据
   * @param pid 业务id，如B商城H5
   */
  export function sgmCustomType(type: any, code: any, msg?: any) {
    try {
      sgmCustom({
        type,
        code: String(code),
        msg: JSON.stringify(msg || ''),
      });
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * 异常类型
   * @param code
   * @param msg
   * @returns
   */
  export function sgmCustomError(code: any, msg?: any) {
    return sgmCustomType('error', code, msg);
  }

  /**
   * 警告类型，业务监控使用这个
   * @param code
   * @param msg
   * @returns
   */
  export function sgmCustomWarn(code: any, msg?: any) {
    return sgmCustomType('warn', code, msg);
  }

  /**
   * 信息类型
   * @param code
   * @param msg
   * @returns
   */
  export function sgmCustomInfo(code: any, msg?: any) {
    return sgmCustomType('info', code, msg);
  }
